import { axios_ } from "@/tools/axios_";
import encrypt from "@/tools/encrypt";
import { doGetRequest, doPostRequest } from "../../../tools/axios_";

export const sendSMSCode = async (phone) => {
  const res = await axios_({
    url: "/api/organization/oauth/captcha",
    method: 'get',
    params: {
      phone,
    },
  });
  return res.data;
}

// 用户协议获取验证吗
export const sendAgreementSMSCode = async (phone, token) => {
  const res = await axios_({
    url: "/api/organization/tenant/user/sendAgreementCaptcha",
    method: 'get',
    headers: {
      'access-token': token
    },
    params: {
      phone,
      source: 'tenant_pc',
    },
  });
  return res.data;
}

export const getMerchantList = async (params, grantType) => {
  const res = await axios_({
    url: `/api/organization/oauth/org/${grantType}`,
    method: 'post',
    data: params
  });
  return res.data;
};

//切换商户
export const switchMerchant = async (data) => {
  let res
  console.log(data)
  return new Promise(async (resolve) => {
    let token = data.token
    if (!token) {
      await getMerchantToken(data, "captcha").then(async (loginRes) => {
        token = loginRes.data.access_token
        localStorage.setItem('platformTokenInfo', `{"access_token":"${token}","token_type":"bearer"}`)
      })
    }
    res = await doPostRequest({
      url: '/api/v2/system/switch_organization',
      data: { ...data, token }
    });
    resolve(res.data);
  })
};
//退出登录
//https://www.test.zhongbaounion.com/api/organization/oauth/token/captcha
export const loginOut = async (data) => {
  console.log(data);
  const res = await doPostRequest({
    url: '/api/v2/system/login_out',
    data
  });
  return res.data;
};

export const getMerchantToken = async (params, grantType) => {
  const res = await axios_({
    url: `/api/organization/oauth/token/${grantType}`,
    method: 'post',
    data: params
  });
  return res.data;
};

export const unifiedPassword = async (params, grantType) => {
  const res = await axios_({
    url: `/api/organization/tenant/user/unifiedPassword/${grantType}`,
    method: 'post',
    data: params
  });
  return res;
};

/**
* 修改密码
* @param phone
* @param captcha
* @param newPassword
* @returns
*/
export const modifyPassword = async ({ phone, captcha, newPassword }, options) => {
  const res = await axios_({
    url: 'modifyPassword',
    method: 'post',
    data: {
      phone,
      captcha,
      newPassword: encrypt(newPassword),
    },
    ...options
  });
  return res.data;
};

export const forgetPassword = async ({ phone, captcha, newPassword }, options) => {
  const res = await axios_({
    url: 'forgetPassword',
    method: 'post',
    data: {
      phone,
      captcha,
      newPassword: encrypt(newPassword),
    },
    ...options
  });
  return res.data;
};

export const setLoginData = (data) => {
  sessionStorage.setItem("loginData", typeof data === "object" ? JSON.stringify(data) : "{}");
};

export const removeLoginData = () => {
  sessionStorage.removeItem("loginData");
};

export const queryPrePhoneSMSCode = async () => {
  return await doGetRequest({
    url: '/api/organization/tenant/user/phone/preChange/captcha',
  })
};

export const validatePrePhoneSMSCode = async (captcha) => {
  return await doGetRequest({
    url: '/api/organization/tenant/user/phone/preChange/check',
    params: {
      captcha
    }
  })
};

export const queryNewPhoneSMSCode = async (phone) => {
  return await doGetRequest({
    url: '/api/organization/tenant/user/phone/change/captcha',
    params: {
      phone
    }
  })
}

export const updatePhone = async (data) => {
  return await doPostRequest({
    url: '/api/organization/tenant/user/phone/change',
    data
  })
}

export const logout = async () => {
  return await doGetRequest({
    url: 'logout'
  });
}

export const queryLoginQrcode = async () => {
  return await doGetRequest({
    url: '/api/organization/wechat/login/qrCode',
  })
}

export const queryLoginQrcodeStatus = async (qrCodeId) => {
  return await doGetRequest({
    url: '/api/organization/wechat/login/qrCode/' + qrCodeId,
  })
}
